<template>
  <div>
    <b-alert v-if="checkMail" show variant="success">{{
      $t("public.views.signIn.alert.checkEmail")
    }}
    </b-alert>

    <b-alert v-if="checkValidation" show variant="success">{{
      $t("public.views.signIn.alert.checkValidation")
    }}
    </b-alert>

    <div class="mobile-hide">
      <h1 class="mb-0">{{ $t("public.views.signIn.getIn") }}</h1>
      <p>{{ $t("public.views.signIn.getInText") }}</p>
    </div>
    <div class="mobile-show text-center">
      <h4>
        Acceder a
        <a class="mb-5" href="#"><img :src="logo" alt="logo" class="logo-public" /></a>
      </h4>
      <br />
      <p>{{ $t("public.views.signIn.getInText") }}</p>
      <br />
    </div>
    <div class="form-auth-pages">
      <b-alert :show="showAlertError" class="text-white bg-danger" dismissible fade variant=" ">
        <div class="iq-alert-icon">
          <i class="ri-information-line"></i>
        </div>
        <div class="iq-alert-text">
          {{ textError }}
        </div>
      </b-alert>
      <b-form>
        <b-form-group label-for="email">
          <template slot="label">{{ $t("public.views.signIn.email") }}: *
          </template>
          <b-form-input id="aaa" v-model="user.email" type="text" v-bind:class="{
            'text-danger': isFormEmailErrors,
            'is-invalid': isFormEmailErrors,
          }" @blur="checkEmail(user.email)"></b-form-input>
          <ul v-if="isFormEmailErrors">
            <li v-for="(error, index) in validator.getErrors('email')" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="password">
          <template slot="label">{{ $t("public.views.signIn.pwd") }}: *
            <router-link class="float-right" to="/public/recover">{{
              $t("public.views.signIn.forget")
            }}
            </router-link>
          </template>
          <b-form-input id="password" v-model="user.password" type="password" v-bind:class="{
            'text-danger': isFormPasswordErrors,
            'is-invalid': isFormPasswordErrors,
          }" @blur="checkPassword(user.password)"></b-form-input>
          <ul v-if="isFormPasswordErrors">
            <li v-for="(error, index) in validator.getErrors('password')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
      </b-form>
      <div class="d-inline-block w-100">
        <b-form-checkbox id="remember" v-model="remember" class="mt-2 pt-1" name="remember" @change="rememberMe">
          {{ $t("public.views.signIn.remember") }}
        </b-form-checkbox>

        <b-button class="btn btn-success float-right" tag="button" type="submit" @click="loginFormStep1">{{
          $t("public.views.signIn.btnLogin")
        }}
        </b-button>
      </div>
      <div class="sign-info">
        <span class="dark-color d-inline-block line-height-2">
          {{ $t("public.forms.signIn.noAccount") }}
          <router-link class="iq-waves-effect pr-4" to="/public/signup">{{
            $t("public.views.signIn.register")
          }}</router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "../../assets/images/logo.png";

import validator from "vue-m-validator";
import routes from "../../router/index";

import authService from "../../services/auth";
import userService from "../../services/user";

import utilsService from "../../services/utils";

export default {
  name: "SignIn",
  components: {},
  data() {
    return {
      logo: logo,
      user: {
        email: "",
        password: "",
        type: "APP",
      },
      showAlertError: false,
      textError: this.$i18n.t("public.views.signIn.errors.errorTextEmail"),
      validator: validator,
      remember: "",

      //Alerts
      checkMail: this.$route.query.checkMail,
      checkValidation: this.$route.query.checkValidation,
    };
  },
  mounted() {
    this.checkAutentication();
    this.initRememberMe();
    this.cleanFormStep1();
  },
  mounted() {

    let url = process.env.VUE_APP_BASE_URL_WEBAPP + '/loader.gif'

    document.documentElement.style.setProperty(
          "--spinner",
          `url(${url})`
        );
  },
  computed: {
    //Form step 1
    isFormEmailErrors() {
      let errors = this.validator.getErrors("email");
      return errors && errors.length > 0;
    },
    isFormPasswordErrors() {
      let errors = this.validator.getErrors("password");
      return errors && errors.length > 0;
    },
  },
  methods: {
    findRoles(request) {
      let authentication = localStorage.getItem("authorization");

      authService
        .getRoles(authentication)
        .then((response) => {
          localStorage.setItem(
            "organizationRoles",
            JSON.stringify(response.data)
          );

          if (request.data.role === "PATIENT") {
            routes.push({ name: "auth.patient.dashboard" });
          } else {
            routes.push({ name: "auth.professional.dashboard" });
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("authorization");
          } else if (error.response && error.response.status === 404) {
            localStorage.removeItem("authorization");
          } else if (error.response && error.response.status === 500) {
            localStorage.removeItem("authorization");
          } else {
            localStorage.removeItem("authorization");
          }
        });
    },
    initRememberMe() {
      if (localStorage.checkbox && localStorage.checkbox !== "") {
        this.remember = true;
        this.email = localStorage.username;
      } else {
        this.remember = false;
        this.email = "";
      }
    },
    rememberMe() {
      if (this.remember && this.email !== "") {
        localStorage.username = this.email;
        localStorage.checkbox = this.remember;
      } else {
        localStorage.username = "";
        localStorage.checkbox = "";
      }
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkPassword(_password) {
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORD || PASSWORD === "",
        name: "password",
        msg: this.$i18n.t("public.views.signIn.errors.pwd"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORD),
        name: "password",
        msg: this.$i18n.t("public.views.signIn.errors.pwd2"),
      };
      this.validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkEmail(_email) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t("public.views.signIn.errors.email"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t("public.views.signIn.errors.email2"),
      };
      this.validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkFormStep1() {
      this.checkEmail(this.user.email);
      this.checkPassword(this.user.password);
    },
    cleanFormStep1() {
      this.user.email = "";
      this.user.password = "";
      this.validator.errors = [];
    },
    loginFormStep1() {
      this.checkFormStep1();
      if (this.validator.errors.length === 0) {
        this.login();
      } else {
      }
    },
    checkLogin() {
      let authentication = localStorage.getItem("authorization");
      this.$awn.asyncBlock(
        authService.checkLogin(authentication),
        (response) => {
          if (response && response.data) {
            localStorage.setItem("type", "APP");
            if (localStorage.getItem("role") === "PATIENT") {
              this.$router.push({ name: "auth.patient.dashboard" });
            } else {
              this.$router.push({ name: "auth.professional.dashboard" });
            }
          }
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("authorization");
          } else if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        },
        ""
      );
    },
    checkAutentication() {
      const loggedIn = localStorage.getItem("authorization");
      if (loggedIn) {
        this.checkLogin();
      }
    },
    async getUser() {
      let self = this;
      userService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response && response.data) {
            if (
              response.data.userOrganizations &&
              response.data.userOrganizations.length != 0
            ) {
              //:TODO hay que recargar la organizacion que tiene por predetirminado el paciente
              self.changeCustomize(response.data.userOrganizations[0]);
            }
          }
        })
        .catch(function (error) {
          self.goToLogin();
        });
    },
    changeCustomize(organization) {
      if (organization.spinner && !organization.spinner.endsWith("/public/picture/")) {
        let url = organization.spinner + "/" + localStorage.getItem("authorization");
        document.documentElement.style.setProperty(
          "--spinner",
          `url(${url})`
        );
      }
    },
    goToLogin() {

      utilsService.auditActivity({ action: "CREATE", module: "AUTH_LOGOUT", info: "" });

      localStorage.removeItem("organizationRoles");
      localStorage.removeItem("authorization");
      localStorage.removeItem("organizationId");
      localStorage.removeItem("type");
      localStorage.removeItem("userId");

      this.$router.push({ name: "public.signin" });
    },
    login() {
      let self = this;

      let data = this.user;

      if (this.$device) {
        data.device = {
          accessClientName: "",
          accessClientType: "",
          accessClientVersion: "",
          accessDeviceBrand: "",
          accessDeviceType: "",
          accessClientOsName: "",
          accessClientOsVersion: "",
          accessClientOsPlatform: "",
        };
        if (this.$device.client) {
          data.device.accessClientName = this.$device.client.name;
          data.device.accessClientType = this.$device.client.type;
          data.device.accessClientVersion = this.$device.client.version;
        }
        if (this.$device.device) {
          data.device.accessDeviceBrand = this.$device.device.brand;
          data.device.accessDeviceType = this.$device.device.type;
        }
        data.device.accessClientOsName = this.$device.os_name.name;
        data.device.accessClientOsVersion = this.$device.os_version;
        data.device.accessClientOsPlatform = this.$device.os_platform;
      }

      this.$awn.asyncBlock(
        authService.login(data),
        (response) => {
          if (response && response.data) {
            localStorage.setItem("authorization", response.data.token);
            localStorage.setItem("role", response.data.role);
            localStorage.setItem("userId", response.data.userId);
            localStorage.setItem("type", response.data.type);
            localStorage.setItem(
              "organizationId",
              response.data.organizationId
            );

            self.getUser();

            self.findRoles(response);

            utilsService.auditActivity({ action: "VIEW", module: "AUTH_LOGIN", info: response.data.userId });

          } else {
            routes.push({ name: "public.signin" });
          }
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            self.showAlertError = true;
            self.user.password = "";
            self.textError = this.$i18n.t(
              "public.views.signIn.errors.errorTextEmail"
            );
          } else if (error.response && error.response.status === 403) {
            self.showAlertError = true;
            self.user.email = "";
            self.user.password = "";
            self.textError =
              "El usuario esta inactivo, contacte con su organización.";
          } else if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        },
        ""
      );
    },
  },
};
</script>
